module.exports = __webpack_public_path__ + "media/images/logo-white-circle-small-63035c0f25d8d852ba23d8f3c688c71a.png";